<template>
  <div class="layout-container">
    <Navigation v-if="loading" />

    <header ref="header">
      <section>
        <div class="search" v-if="searchVisible">
          <input placeholder="搜索" v-model="searchText"></input>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
          <div id="result" v-if="resultVisible">
            <div class="warning" ref="tip">
              <i class="el-icon-warning"></i>
              <span>暂无您要搜索的服务</span>
            </div>
            <div class="item" v-for="item in findServiceList" :key="item.employId"
              @click="$router.push(`guide?employId=${item.employId}&hall=${key === '/hall'}`)">
              <span>{{ item.employName }}</span>
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </section>
    </header>
    <main>
      <router-view :key="key"></router-view>
    </main>

    <Footer v-if="loading" />

    <aside v-if="searchVisible && isLogin">
      <a :href="jumpURL + '/systemReminder'" target=" _blank">
        <img src="../assets/bell.svg" alt="" width="40">
        <span>我的消息</span>
      </a>
      <a @click="$router.push('/collection')">
        <img src="../assets/star.svg" alt="" width="40">
        <span>我的收藏</span>
      </a>
    </aside>

    <div class="smart" @click="openDrawer">
      <img src="../assets/smartBaby.gif" alt="">
    </div>

    <div class="drawer" ref="drawer">
      <div class="title flex-row">
        <span>AI分析</span>
        <i class="el-icon-right" @click="closeDrawer" style="cursor: pointer;"></i>
      </div>
      <div class="card">
        <div class="infoItem">
          <img src="../assets/ai.png" alt="">
          <div class="text">
            <span>很</span>
            <span>高</span>
            <span>兴</span>
            <span>认</span>
            <span>识</span>
            <span>你</span>
            <span>~</span>
          </div>
        </div>
        <div class="infoSelf" ref="infoSelf">
          <div v-for="item, index in infoList" :key="index" class="infoSelfItem">
            <span>{{ item.text }}</span>
            <img :src="item.img" alt="">
          </div>
        </div>
        <el-input type="textarea" placeholder="给AI发个消息吧~" v-model="inpVal" @keyup.enter.native="sendInfo"></el-input>
        <img src="../assets/send.png" ref="sendImg" style="cursor: pointer;" @click="sendInfo">
      </div>
    </div>
  </div>
</template>

<script>
import { getServiceList } from '../views/hall/api'
import * as api from './api'
const { jumpURL } = projectConfig
export default {
  name: 'Layout',
  components: {
    Navigation: () => import('../components/Navigation'),
    Footer: () => import('../components/Footer'),
  },
  data() {
    return {
      jumpURL,
      loading: false,
      baseUrl: localStorage.getItem('baseUrl'),
      isLogin: localStorage.getItem('sys_token'),
      userRole: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userDict : null,
      searchText: '',
      resultVisible: false,
      serviceList: [],
      findServiceList: [],
      drawer: false,
      inpVal: '',
      infoList: []
    }
  },
  computed: {
    key() {
      return this.$route.path
    },
    searchVisible() {
      return ['/home', '/hall'].includes(this.$route.path)
    }
  },
  watch: {
    searchText(val) {
      this.resultVisible = Boolean(this.searchText.trim())
      if (val) {
        this.findServiceList = []
        this.serviceList.forEach(item => {
          if (item.employName.indexOf(val) !== -1) {
            this.findServiceList.push(item)
          }
        })
        this.$nextTick(() => {
          this.$refs.tip.style.opacity = this.findServiceList.length ? 0 : 1
          this.$refs.tip.style.display = this.findServiceList.length ? 'none' : 'block'
        })
      } else {
        this.findServiceList = []
        this.$nextTick(() => {
          this.$refs.tip.style.opacity = 0
        })
      }
    }
  },
  async created() {
    // baseUrl
    const { data: { settingValue } } = await api.getConfigInfo('minio_baseUrl')
    localStorage.setItem('baseUrl', settingValue)
    // banner
    const { data: { settingValue: banner } } = await api.getConfigInfo('workOnline_banner')
    this.$refs.header.style.backgroundImage = `url(${localStorage.getItem('baseUrl')}${banner})`
    // logo
    const { data: { settingValue: logo } } = await api.getConfigInfo('system_logo')
    localStorage.setItem('logo', logo)
    this.loading = true
    const { data: { employList } } = await getServiceList({
      status: 1,
      roles: this.userRole == 0 ? 2 : this.userRole == 2 ? 1 : this.userRole == 4 ? 3 : ''
    })
    this.serviceList = employList
  },
  methods: {
    sendInfo() {
      this.infoList.push({ text: this.inpVal, img: require('../assets/ai.png') })
      this.inpVal = ''
    },
    jumpUrlMsg() {
      window.open(jumpURL + '/systemReminder', '_blank')
    },
    openDrawer() {
      this.$refs.drawer.style.opacity = 1
      this.$refs.drawer.style.width = '600px'
      this.$refs.drawer.style.padding = '30px'
      this.$refs.sendImg.style.opacity = 1
    },
    closeDrawer() {
      this.$refs.drawer.style.width = 0
      this.$refs.drawer.style.opacity = 0
      this.$refs.sendImg.style.opacity = 0
      this.inpVal = ''
    }
  }
}
</script>

<style>
:root {
  --inner-width: 1440px;
  --nav-height: 76px;

  #service {
    height: 100px;
    border-radius: 2px;
    border: 1px solid #D9D9D9;
    padding: 20px;
    color: #999;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: 300ms;
    cursor: pointer;

    &:hover {
      border-color: var(--mainColor);
      scale: .97;
    }

    p {
      display: flex;
      gap: 10px;

      i {
        font-size: 20px;
        color: var(--mainColor);
      }

      span:nth-of-type(1) {
        font-size: 18px;
        color: #333;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      span:nth-of-type(2) {
        font-size: 14px;
        color: #999;
        margin-left: auto;

        &::before {
          content: '·';
          color: var(--mainColor);
          margin-right: 3px;
          font-weight: bold;
        }
      }
    }

    div {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
    }
  }
}
</style>
<style lang="scss" scoped>
.layout-container {
  min-width: max-content;
  position: relative;

  header {
    // background-image: url(../assets/banner.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 363px;
    transition: 800ms ease-in-out;
    margin-top: calc(0px - var(--nav-height));

    section {
      width: var(--inner-width);
      height: 100%;
      margin: auto;
      position: relative;

      .search {
        position: absolute;
        right: 0;
        bottom: 110px;
        display: flex;
        align-items: center;

        input {
          width: 295px;
          height: 55px;
          padding: 0 50px;
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.9);
          border: none;
          outline: none;
        }

        svg {
          width: 20px;
          color: $mainColor;
          position: absolute;
          left: 20px;
        }

        #result {
          width: 295px;
          height: 149px;
          margin-top: 5px;
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
          border-radius: 6px;
          position: absolute;
          top: 60px;
          color: $contentColor;
          overflow: auto;
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 16px;

          .warning {
            font-size: 14px;
            font-weight: bold;
            text-align: center;
            opacity: 0;

            span {
              margin-left: 6px;
            }
          }

          .item {
            font-size: 16px;
            cursor: pointer;
            transition: 300ms;
            display: flex;
            justify-content: space-between;
            align-items: center;

            i {
              opacity: 1;
              margin-left: 6px;
            }

            &:hover {
              transform: translateX(10px);
              transition: 300ms;
              color: $mainColor;
              font-weight: bold;
            }
          }
        }
      }
    }
  }

  aside {
    position: fixed;
    top: 450px;
    right: 30px;
    box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.05);

    a {
      width: 100px;
      aspect-ratio: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 14px;
      border-radius: 2px;
      background: #fff;
      color: #999;
      transition: 300ms;

      &:hover {
        background: $mainColor;
        color: #fff;

        img {
          filter: brightness(100)
        }
      }

      &:nth-child(1)::before {
        content: '';
        width: 10px;
        aspect-ratio: 1;
        border-radius: 50%;
        background: red;
        position: absolute;
        top: 16px;
        right: 35px;
        z-index: 1;
      }
    }
  }

  .smart {
    position: fixed;
    top: 720px;
    right: 30px;
    cursor: pointer;
    // box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.05);

    img {
      height: 150px;
    }
  }

  .drawer {
    position: fixed;
    top: var(--nav-height);
    height: calc(100vh - var(--nav-height));
    width: 0;
    padding: 0px;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-shadow: 0px 0px 10px 0px rgba(129, 140, 255, 0.2), inset 0px 0px 8px 0px #FFFFFF;
    background: linear-gradient(to top left, rgba(19, 212, 188, 0) 0%, rgba(19, 212, 188, 0.2) 100%),
      linear-gradient(95deg, rgba(129, 140, 255, 0) 0%, rgba(129, 140, 255, 0.2) 100%),
      linear-gradient(to bottom right, rgba(129, 140, 255, 0) 0%, rgba(129, 140, 255, 0.2) 100%);
    background-color: rgba(255, 255, 255, 0.7);
    transition: 300ms ease-in-out;


    .title {
      color: $titleColor;
      font-size: 22px;
      font-weight: bold;
    }

    .card {
      flex-grow: 1;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: inset 0px 0px 10px 0px rgba(129, 140, 255, 0.44);
      position: relative;
      display: flex;
      flex-direction: column;

      >img {
        position: absolute;
        bottom: 20px;
        right: 20px;
        opacity: 0;
      }

      .infoItem {
        display: flex;
        align-items: center;

        img {
          margin-right: 10px;
        }

        .text span {
          opacity: 0;
          animation: fadeIn 5s forwards;
          font-size: 18px;

          &:nth-child(1) {
            animation-delay: 2s;
          }

          &:nth-child(2) {
            animation-delay: 2.2s;
          }

          &:nth-child(3) {
            animation-delay: 2.3s;
          }

          &:nth-child(4) {
            animation-delay: 2.4s;
          }

          &:nth-child(5) {
            animation-delay: 2.5s;
          }

          &:nth-child(6) {
            animation-delay: 2.6s;
          }

          &:nth-child(7) {
            animation-delay: 2.7s;
          }
        }

        @keyframes fadeIn {
          to {
            opacity: 1;
          }
        }
      }

      .infoSelf {
        display: flex;
        flex-direction: column;
        align-self: flex-end;
        gap: 10px;
        font-size: 18px;

        .infoSelfItem {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          img {
            margin-left: 10px;
          }
        }
      }

      ::v-deep.el-textarea {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 200px;
        padding: 20px;

        // border: 2px solid;
        // border-image: linear-gradient(89deg, rgba(19, 212, 188, 1), rgba(129, 140, 255, 1)) 2 2;

        border: 4px solid transparent;
        border-radius: 8px;
        background-color: #fff;
        background-clip: padding-box;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          z-index: -1;
          margin: -4px;
          border-radius: inherit;
          /*important*/
          background: linear-gradient(89deg, rgba(19, 212, 188, 1), rgba(129, 140, 255, 1));
        }

        &__inner {
          height: 100%;
          overflow: auto;
          border: none;
          background: transparent;
          // resize: none;
        }
      }
    }
  }
}
</style>